
<div mat-dialog-title class="red">Delete Selected Rebalances</div>
<mat-dialog-content>
  <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button>
  <div>
    <table>
      <tr>
        <td style="vertical-align: top;">
          <span class="material-icons red" style="font-size: 36px;">delete_forever</span>
        </td>
        <td>
          @if (scheduledRebalances) {
            <div style="margin-bottom: 10px;"><strong>{{scheduledRebalances.length}} rebalances selected</strong></div>
          }
        </td>
      </tr>
    </table>
  </div>
  <!-- <div>
  <table width="100%">
    <tr>
      <td style="vertical-align: top; width: 72px; padding: 10px 0;"><strong>Rebalances</strong></td>
      <td style="padding: 10px; background-color: #fad1cf;">
        <div id="selectedRebalances" style="overflow-y: auto; width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #CFCFCF; padding: 5px; background-color: #FFFFFF;">
          <table id="deleteRebalanes" style="width:100%;" *ngIf="scheduledRebalances && scheduledRebalances.length > 0">
            <tr *ngFor="let rebalance of scheduledRebalances">
              <td style="max-width: 410px; white-space:nowrap; text-overflow: ellipsis;">{{rebalance.analysisName}}</td>
            </tr>
          </table>
        </div>
      </td>
    </tr>
  </table>
</div> -->
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
  <button mat-button id="deleteButton" class="btn-medium-primary red" (click)="deleteSelectedSchdReblances()"><span class="material-icons" style="font-size: 16px; margin-top: -3px;">delete_forever</span>&nbsp;Delete</button>
</mat-dialog-actions>